const MASK_PREFIX = '••••'

/** Account and routing numbers are shown as `••••1234` everywhere except their entry field. */
export const maskAccountNumber = (value?: string | null): string => {
  const trimmed = value?.trim() ?? ''

  if (trimmed === '') {
    return '—'
  }

  return `${MASK_PREFIX}${trimmed.slice(-4)}`
}
